import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Input, Modal, Button,JoditEditor } from "../../ui/ot";
import { Form, notification } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import ProTableOt from "../../utility/ProTable_ot";

const QAndAList = (props) => {
    const submit = useRef();
    const editor = useRef(null);
    const actionRef = useRef([]);
    const [form] = Form.useForm(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [columns, set_columns] = useState([]);
    const [content, setContent] = useState("");
    const [pre_content, set_pre_Content] = useState("");
    const [status, set_status] = useState(false);
    const [type, setType] = useState(0);
    const [check, set_check] = useState([]);
    const [check_list, set_check_list] = useState([]);
    const [id, setId] = useState([]);
    useEffect(() => {
        set_status(content === pre_content);
    }, [content, pre_content]);
    useEffect(() => {
        set_columns([
            {
                key: "question_and_answer_id",
                title: "編號",
                dataIndex: "question_and_answer_id",
            },
            {
                key: "title",
                title: "問題標題",
                dataIndex: "title",
            },
        
            {
                title: "編輯",
                render: (info) => <Button onClick={() => edit(info)}>編輯</Button>,
            },
        ]);
    }, []);
    const rowSelection = {
        selectedRowKeys: check_list,
        onChange: (selectedRowKeys) => {
            set_check_list(selectedRowKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === "Disabled User",
            name: record.name,
        }),
    };
    const handleOK = (info) => {
        if (type) {
            axios
                .post(`/dynamicWebsite/backend/question_and_answer`, [
                    {
                        title: info.title,
                        content: content,
                    },
                ])
                .then((response) => {
                    success_or_failure(response.data.status) &&
                        actionRef.current.reload();
                });
        } else {
            axios
                .patch(`/dynamicWebsite/backend/question_and_answer`, [
                    {
                        title: info.title,
                        content: content,
                        question_and_answer_id: id,
                    },
                ])
                .then((response) => {
                    success_or_failure(response.data.status) &&
                        actionRef.current.reload();
                });
        }
        set_status(true);
        setIsModalOpen(false);
        setContent("");
        form.resetFields();
    };
    const handleCancel = () => {
        if (status) {
            setIsModalOpen(false);
            setContent("");
            set_pre_Content("");
            form.resetFields();
        } else {
            Modal.confirm({
                title: "提示",
                content: "您的編輯將不會被儲存",
                onOk: () => {
                    setIsModalOpen(false);
                    setContent("");
                    set_pre_Content("");
                    form.resetFields();
                },
                okText: "離開",
                cancelText: "取消",
            });
        }
    };
    const edit = (info) => {
        setContent(info.content);
        set_pre_Content(info.content);
        form.setFieldValue("title", info.title);
        setId(info.question_and_answer_id);
        setIsModalOpen(true);
        setType(0);
    };
    const add = () => {
        setIsModalOpen(true);
        setType(1);
    };
    const del = () => {
        if (check_list && check_list.length > 0) {
            Modal.confirm({
                title: "確認刪除?",
                okText: "確認",
                okType: "danger",
                cancelText: "取消",
                onOk: () => {
                    axios
                        .delete(`/dynamicWebsite/backend/question_and_answer`, {
                            data: check_list.map((tmp) => ({
                                question_and_answer_id: parseInt(tmp),
                            })),
                        })
                        .then((response) => {
                            success_or_failure(response.data.status) &&
                                actionRef.current.reload();
                        });
                    set_check_list([]);
                },
            });
        } else {
            Modal.warning({
                title: "提示",
                content: "至少選擇一項",
            });
        }
    };
    const success_or_failure = (value) => {
        if (value === "success") {
            notification.success({
                message: "成功",
                description: "編輯成功",
            });
            return true;
        } else {
            notification.error({
                message: "錯誤",
                description: "發生未知錯誤",
            });
            return false;
        }
    };
    const getData = (param, sort, filter, checklist) => {
        return axios
            .get(`/dynamicWebsite/frontend/question_and_answer`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    order:
                        sort &&
                        Object.entries(sort)
                            .map(([map_key, map_value], i) =>
                                map_key === "undefined"
                                    ? null
                                    : {
                                        column: map_key,
                                        type: map_value,
                                    }
                            )
                            .filter((tmp) => tmp !== null),
                    custom_filter_key: check,
                    custom_filter_value: param?.keyword,
                },
            })
            .then((response) => {
                return response.data;
            });
    };

    return (
        <>
            <Row gutter={[10, 20]} justify="space-around">
                <Col span={24}>
                    {/* <div style={{ borderRadius: "0px 15px 15px 15px" }}> */}
                    <ProTableOt
                        actionRef={actionRef}
                        check={check}
                        request={getData}
                        setCheck={(e) => set_check(e)}
                        columns={columns}
                        cardBordered
                        rowKey={"question_and_answer_id"}
                        rowSelection={rowSelection}
                        toolBarRender={() => [
                            <Button onClick={() => add()}>新增</Button>,
                            <Button onClick={() => del()}>刪除</Button>,
                        ]}
                    />
                    {/* </div> */}
                </Col>
            </Row>
            <Modal
                forceRender
                open={isModalOpen}
                onOk={(e) => submit.current.click()}
                onCancel={handleCancel}
                okText="確認"
                cancelText="取消"
                maskClosable={false}
                width={"80vw"}
                title={"問題編輯"}
            >
                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        remember: false,
                    }}
                    autoComplete="off"
                    onFinish={(info) => handleOK(info)}
                >
                    <Form.Item
                        label="標題"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: "請勿空白",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item hidden>
                        <Button htmlType="submit" ref={submit} />
                    </Form.Item>
                </Form>
                <JoditEditor
                    ref={editor}
                    value={content}
                    config={{
                        allowResizeTags: false,
                        imageDefaultWidth: "100%",
                        language: "zh_tw",
                        i18n: {
                            zh_tw: {
                                Default: "預設",
                                "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.":
                                    "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                                Anchor: "Anchor",
                                Margins: "外邊距（Margins）",
                                top: "top",
                                right: "right",
                                bottom: "bottom",
                                left: "left",
                                Classes: "Classes",
                                Src: "Src",
                                Title: "Title",
                                Link: "Link",
                                file: "file",
                                "Image properties": "圖片屬性",
                                "Your code is similar to HTML. Keep as HTML?":
                                    "你黏貼的文本是一段html代碼，是否保留源格式",
                                "Paste as HTML": "html黏貼",
                                "Insert as Text": "把html代碼視為普通文本",
                                "Error on load list": "加載list錯誤",
                                Break: "Pause",
                                "No follow": "No follow",
                                " URL": "URL",
                                Crop: "Crop",
                                Circle: "圓圈",
                                Dot: "點",
                                Quadrate: "方形",
                                Find: "搜尋",
                                "Insert className": "插入班级名稱",
                                "Press Alt for custom resizing": "按Alt自定義調整大小",
                            },
                        },
                        uploader: {
                            insertImageAsBase64URI: true,
                            imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
                        },
                    }}
                    tabIndex={1}
                    onBlur={(newContent) => setContent(newContent)}
                />
            </Modal>
        </>
    );
};

export default QAndAList;
